import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

import tinycolor from "tinycolor2";

const primary = "#536DFE";
const secondary = "#FF5C93";
const warning = "#FFC260";
const success = "#3CD4A0";
const info = "#9013FE";

const lightenRate = 7.5;
const darkenRate = 15;

export default function generateMuiTheme(type, primary, secondary) {
  return responsiveFontSizes(
    createMuiTheme({
      typography: {
        fontFamily: ["Inter", "Arial", "sans-serif"].join(","),
      },

      palette: {
        type: "dark",
        text: { primary: "#fff", secondary: "#9fa0a7" },
        success: { main: "#4aa96c" },
        error: { main: "#D32F2F" },
        divider: "#3B3A48",
        background: {
          default: "#2F2D30",
          paper: "#333244",
        },
        primary: {
          light: tinycolor(primary).lighten(lightenRate).toHexString(),
          dark: tinycolor(primary).darken(darkenRate).toHexString(),
          main: "#1178F8",
        },
        secondary: {
          main: "#000",
          contrastText: "#fff",

          light: tinycolor(secondary).lighten(lightenRate).toHexString(),
          dark: tinycolor(secondary).darken(darkenRate).toHexString(),
        },
        warning: {
          main: warning,
          light: tinycolor(warning).lighten(lightenRate).toHexString(),
          dark: tinycolor(warning).darken(darkenRate).toHexString(),
        },
        success: {
          main: success,
          light: tinycolor(success).lighten(lightenRate).toHexString(),
          dark: tinycolor(success).darken(darkenRate).toHexString(),
        },
        info: {
          main: info,
          light: tinycolor(info).lighten(lightenRate).toHexString(),
          dark: tinycolor(info).darken(darkenRate).toHexString(),
        },
        common: { white: "#fff", black: "#000", sidePanel: "#3D3C4E" },
      },
      customShadows: {
        widget:
          "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
        widgetDark:
          "0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
        widgetWide:
          "0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
      },
      overrides: {
        MuiTypography: {
          root: { color: "#fff" },
        },
        MuiTooltip: {
          tooltip: {
            fontSize: "1rem",
            color: "#fff",
            backgroundColor: "#000",
          },
        },
      },
    })
  );
}

// Primary Background:#212032
// Secondary Background(Right Side Panel):#333244
// Right Side panel- card bg:#3D3C4E
// // Primary text color:#ffffff     =  used
// // Secondary text color:#9fa0a7    =  used
// // Success:#4aa96c    =  used
// // Error:#D32F2F    =  used
// Hint bg:#525D6A
// Hint Text:#ffffff
// // Divider:#3B3A48  ==  used
// Icon:#ffffff(not selected), #1C1F2E(selected)
